import { forwardRef, Ref, SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {
  color?: string;
  size?: string | number;
}

const WarningTriangle = forwardRef(function WarningTriangle(props: Props, ref: Ref<SVGSVGElement>) {
  const { color = '#F7BE2C', size = 16, ...others } = props;

  return (
    <svg
      fill="none"
      height={size}
      ref={ref}
      viewBox="0 0 16 14"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path
        d="M7.05769 0.622288C7.47649 -0.0863363 8.52351 -0.0863355 8.94231 0.622289L15.8526 12.3146C16.2714 13.0232 15.7479 13.909 14.9103 13.909H1.08971C0.2521 13.909 -0.271406 13.0232 0.1474 12.3146L7.05769 0.622288Z"
        fill={color}
      />
      <path
        clipRule="evenodd"
        d="M7.61621 9.25222L7.61621 4.69678L8.3416 4.69678L8.3416 9.25222L7.61621 9.25222Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M7.61621 11.0744L7.61621 10.1633L8.3416 10.1633L8.3416 11.0744L7.61621 11.0744Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
});

export default WarningTriangle;
